import React, { useContext, useEffect, useRef, useState } from 'react';
import { GlobalStateDataContext } from '../../context-api/data-provider/GlobalStateDataProvider';
import RippleAnimation from '../../atomic/RippleAnimation/RippleAnimation';
import AtomicButton from '../../atomic/button/Button';


const NewOrderAlert = (props) => {

    const {
        setOpenOrderAlert,
        setPageReloaded,
    } = useContext(GlobalStateDataContext)


    const audioRef = useRef(null);

    useEffect(() => {
        if (audioRef.current) {
            audioRef.current.play().catch(e => {
                console.log('Audio playback failed:', e);
            });
        }
    }, []);



    // Stop audio on button click
    const handleAccept = () => {
        setOpenOrderAlert(false)
        setPageReloaded(false)
    };

    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column'
        }}>

            <div style={{
                marginTop: '30px',
                fontSize: '20px',
                color: 'rgb(24, 20, 54)',
                fontFamily: 'Inter Medium'

            }}> 🎉 Woohoo! You’ve got a new order – time to bring the flavor!</div>

            <RippleAnimation />
            <AtomicButton
                label="Got It!"
                handleSubmit={handleAccept}
                style={{
                    color: 'white',
                    backgroundColor: 'rgb(24, 20, 54)',
                    width: '400px',
                    marginTop: '360px',

                }}
                loading={false}
                disabled={false}
            />
            <audio ref={audioRef}
                src="/nokia_songette.mp3"
                preload="auto"
                // controls={true}
                // muted={true}
                loop={true}
            />

        </div>
    )
}

export default NewOrderAlert